import style from '../OnboardingEgyptLuckyV1.css';
import useTranslation from '../../../../localization/i18n.context';
import Alert from '../../../shared/Alert/Alert';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/TextField/TextField';
import Title from '../../../shared/Typography/Title';

const StepField = {
  FIRST_NAME: 'firstName',
  SECOND_NAME: 'secondName',
  THIRD_NAME: 'thirdName',
  FAMILY_NAME: 'familyName',
};

export default function FormStep1({ onInputChange, onButtonClick, data = {} }) {
  const { t } = useTranslation();

  const isButtonEnabled = Object.values(StepField).every(
    field => data[field].value && data[field].value?.trim(),
  );

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-title']}>
          <Title text={t('Enter your full name as written in your ID')} />
        </div>
        <div className={style['form-alert']}>
          <Alert
            hasIcon
            message={t(
              'Please enter your full name in Arabic or it will impact your approval',
            )}
          />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <TextField
              label={t('First name')}
              placeholder={t('Moustafa')}
              onInput={onInputChange}
              value={data[StepField.FIRST_NAME]?.value}
              name={StepField.FIRST_NAME}
            />
          </div>

          <div className={style['form-control']}>
            <TextField
              label={t('Second name')}
              placeholder={t('Mohamed')}
              onInput={onInputChange}
              value={data[StepField.SECOND_NAME]?.value}
              name={StepField.SECOND_NAME}
            />
          </div>

          <div className={style['form-control']}>
            <TextField
              label={t('Third name')}
              placeholder={t('Ali')}
              onInput={onInputChange}
              value={data[StepField.THIRD_NAME]?.value}
              name={StepField.THIRD_NAME}
            />
          </div>
          <div className={style['form-control']}>
            <TextField
              label={t('Family name')}
              placeholder={t('Soliman')}
              onInput={onInputChange}
              value={data[StepField.FAMILY_NAME]?.value}
              name={StepField.FAMILY_NAME}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth onClick={onButtonClick} disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
FormStep1.Type = 'FormStep1';
FormStep1.EventName = 'personal_info_arabic';
